<template>
  <div>
    <DxButton class="record-print-btn" icon="trash" @click="onItemClick" />
  </div>
</template>
<script>
import { TransactionListService } from "../_services/api/templates/transactions-list.services";
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    dataField: {
      type: String,
      default: "Code",
    },
    refresh: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    // eslint-disable-next-line no-unused-vars
    async onItemClick(e) {
      if (!e.event) return;

      let confirmDelete = await this.$confirm(
        "Are you sure you want to delete this record ?",
        "Delete Record"
      );
      if (confirmDelete) {
        var referenceData = undefined;
        if (this.data.column.DeleteOptions)
          referenceData = this.data.column.DeleteOptions;

        if (referenceData)
          TransactionListService.deleteRecord({
            url: referenceData.URL,
            code: this.data.data[referenceData.ReferenceKey],
            codeType: referenceData.KeyType,
          })
            .then((res) => {
              if (res) this.refresh();
              this.showLoading(false);
            })
            .catch((err) => {
              if (err) this.showLoading(false);

              this.$store.dispatch("ui/setServerError", {
                error: err,
                title: "Failed",
              });
            });
        else {
          this.showLoading(false);
          this.$alert("Reference Data Missing", "Error");
        }
      }
    },
  },
};
</script>

<style lang="scss"></style>
